<template>
  <div id="app">

    <!-- TITLE -->
    <transition name="fade">
      <div v-if='titleActive && $route.name !== "video"' class="title" @click="titleActive = false">
        <img id="title" :src="titleImg">
        <img id="close" :src="closeIcn">
      </div>
    </transition>

    <!-- MOBILE NAV: About -->
    <div @click='showMobileAbout' class='mobile-nav about' :class="{hidden: navHidden}"></div>

    <!-- MOBILE NAV: Credits -->
    <div @click='showMobileQuotes' class='mobile-nav quotes' :class="{hidden: navHidden}"></div>

    <!-- COLOPHON -->
    <div v-if='$route.name !== "video"' class='colophon' @click='toggleNavigation'>
      <vue-typer :text='colophonText'></vue-typer>
    </div>

    <!-- CREDITS -->
    <div id='credits' class="quart credits" :class="{collapsed: quotesCollapsed, hidden: navHidden,'show-mobile': mobileQuotes}">
      <!-- Margin toggle area-->
      <div @click='toggleQuotes' class='toggle-area'></div>
      <p v-if='$route.name == "video"'>
        <router-link class='colophon-link' to='/'>Colophon ></router-link>
      </p>
      <span v-if='$route.name == "home" && main.biographies' v-html='main.biographies'></span>
      <span v-if='$route.name == "video" && main.single.data.credits && main.single.data.credits' v-html="main.single.data.credits"></span>
    </div>

    <!-- ABOUT -->
    <div id='about' class="quart about" :class="{collapsed: aboutCollapsed, hidden: navHidden,'show-mobile': mobileAbout}">
      <!-- Margin toggle area-->
      <div @click='toggleAbout' class='toggle-area'></div>
      <div class="header"></div>
      <div class="content">
        <pre v-if='$route.name == "video" && main.single.data && main.single.data.text[0]'>{{main.single.data.text[0].text}}</pre>
        <pre v-if=' $route.name=="home" && main.about.data && main.about.data.text[0]'>{{main.about.data.text[0].text}}</pre>
      </div>
    </div>

    <!-- INDEX -->
    <div id='index' class="quart index" :class="{collapsed: indexCollapsed, hidden: navHidden}">
      <!-- Margin toggle area-->
      <div v-if='indexCollapsed' @click='toggleIndex' class='toggle-area'></div>
      <!-- Vertical title bar -->
      <div v-if='$route.name==="video" && indexCollapsed' class="vertical-title">
        <span v-if='main.single.data && main.single.data.title && main.single.data.title[0]'>{{main.single.data.title[0].text}}</span>
        <span v-if='main.single.data && main.single.data.media && main.single.data.media[0] && main.single.data.media[0].length > 0'>, {{main.single.data.media[0].text}}</span>
        <span v-if='main.single.data && main.single.data.year[0] && main.single.data.year[0].length > 0'>, {{main.single.data.year}}</span>
      </div>
      <!-- Top Bar -->
      <div class="txt top">
        <p class="left"></p>
        <p class="right">
          <span @click='textIndex=true; imageIndex=false;' :class='{ "active": textIndex}' class='index-switch'>tracks</span> |
          <span @click='imageIndex=true; textIndex=false;' :class='{ "active": imageIndex}' class='index-switch'>images</span>
        </p>
      </div>
      <!-- Image index -->
      <div v-if='imageIndex' class='image-index'>
        <div class='preloader'>
          <img v-for='item in main.works' :src='item.data.images[0].image.url'>
        </div>
        <div id='img-slide-wrapper'>
          <div>
            <router-link :to='main.works[imageSlider.index].slugs[0]'>
              <img :src="main.works[imageSlider.index].data.images[0].image.url">
            </router-link>
          </div>
        </div>
        <div class='slide-navigation'>
          <div class=' nav-arrow'>
            <span v-show='imageSlider.index !==0' @click='imageSlider.index--'>&lt;</span>
          </div>
          <div>{{main.works[imageSlider.index].data.title[0].text}}</div>
          <div class='nav-arrow'>
            <span v-show='imageSlider.index < (main.works.length - 1)' @click='imageSlider.index++'>&gt;</span>
          </div>
        </div>
      </div>
      <!-- Text index -->
      <div v-if='textIndex' class='text-index'>
        <ol>
          <li v-for='work in main.works'>
            <router-link :to='work.slugs[0]' class='text-index-item'>
              <div class='index-number'>
                <span v-if='work.data.order < 10'>0</span>{{work.data.order}}.
              </div>
              <div class='index-title'>
                <span v-if='work.data.title && work.data.title[0]'>{{work.data.title[0].text}}</span>
              </div>
            </router-link>
          </li>
        </ol>
      </div>
    </div>

    <!-- View to show the videos -->
    <transition name="fade">
      <router-view @hideNav='hideNavigation'></router-view>
    </transition>

  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import {VueTyper} from 'vue-typer'
import away from 'away'
import PerfectScrollbar from 'perfect-scrollbar'

export default {
  name: 'app',
  components: {
    VueTyper
  },
  data() {
    return {
      titleImg: require('./assets/img/title.svg'),
      closeIcn: require('./assets/img/x.svg'),
      titleActive: true,
      quotesCollapsed: false,
      aboutCollapsed: false,
      indexCollapsed: false,
      colophonText: '**',
      textIndex: true,
      imageIndex: false,
      navHidden: false,
      mobileQuotes: false,
      mobileAbout: false,
      timer: {},
      imageSlider: {
        index: 0
      },
      ps: [],
      scrollConfig: {
        minScrollbarLength: 80,
        suppressScrollX: true
      }
    }
  },
  computed: {
    ...mapState(['main'])
  },
  methods: {
    ...mapActions(['GET_POSTS']),
    showNavigation() {
      this.quotesCollapsed = false
      this.aboutCollapsed = false
      this.indexCollapsed = false
    },
    hideNavigation() {
      this.quotesCollapsed = true
      this.aboutCollapsed = true
      this.indexCollapsed = true
      this.mobileQuotes = false
      this.mobileAbout = false
      this.scrollUpAllQuarts()
    },
    toggleNavigation() {
      if (this.quotesCollapsed && this.aboutCollapsed && this.indexCollapsed) {
        this.quotesCollapsed = false
        this.aboutCollapsed = false
        this.indexCollapsed = false
      } else {
        this.quotesCollapsed = true
        this.aboutCollapsed = true
        this.indexCollapsed = true
        this.mobileQuotes = false
        this.mobileAbout = false
      }
      this.scrollUpAllQuarts()
    },
    toggleIndex() {
      this.indexCollapsed = !this.indexCollapsed
      document.getElementById('index').scrollTop = 0
    },
    toggleAbout() {
      this.aboutCollapsed = !this.aboutCollapsed
      document.getElementById('about').scrollTop = 0
    },
    toggleQuotes() {
      this.quotesCollapsed = !this.quotesCollapsed
      document.getElementById('credits').scrollTop = 0
    },
    showMobileAbout() {
      this.mobileQuotes = false
      this.aboutCollapsed = false
      this.indexCollapsed = true
      this.mobileAbout = !this.mobileAbout
      document.getElementById('about').scrollTop = 0
    },
    showMobileQuotes() {
      this.mobileAbout = false
      this.quotesCollapsed = false
      this.indexCollapsed = true
      this.mobileQuotes = !this.mobileQuotes
      document.getElementById('credits').scrollTop = 0
    },
    scrollUpAllQuarts() {
      document.getElementById('index').scrollTop = 0
      document.getElementById('about').scrollTop = 0
      document.getElementById('credits').scrollTop = 0
    },
    toggleCustomScrollbars(mq) {
      if (mq.matches) {
        this.destroyCustomScrollbars()
      } else {
        this.initCustomScrollbars()
      }
    },
    initCustomScrollbars() {
      console.log('init scrollbars')
      window.setTimeout(() => {
        this.ps[0] = new PerfectScrollbar('#index', this.scrollConfig)
        this.ps[1] = new PerfectScrollbar('#about', this.scrollConfig)
        this.ps[2] = new PerfectScrollbar('#credits', this.scrollConfig)
      }, 500)
    },
    destroyCustomScrollbars() {
      console.log('destroy scrollbars')
      if (this.ps[0]) {
        console.log('destroy scrollbars yepp')
        this.ps[0].destroy()
        this.ps[1].destroy()
        this.ps[2].destroy()
        this.ps[0] = null
        this.ps[1] = null
        this.ps[2] = null
      }
    }
  },
  mounted() {
    // ***
    this.GET_POSTS()
    // Hide nav in video view
    if (this.$route.name === 'video') {
      this.hideNavigation()
    }
    // Initialize scrollbars if not on mobile
    if (!window.matchMedia('(max-width: 900px)').matches) {
      this.initCustomScrollbars()
    }
    // ***
    this.timer = away(3000)
    this.timer.on('idle', () => {
      if (this.$route.name === 'video' && this.quotesCollapsed && this.indexCollapsed && this.aboutCollapsed) {
        this.navHidden = true
      }
    })
    this.timer.on('active', () => {
      if (this.$route.name === 'video') {
        this.navHidden = false
      }
    })
    // *** Eventlistener for media query change
    if (window.matchMedia) {
      const mq = window.matchMedia('(max-width: 900px)')
      mq.addListener(this.toggleCustomScrollbars)
      this.toggleCustomScrollbars(mq)
    }
  },
  watch: {
    'main.colophon.data.text'() {
      this.main.colophon.data.text.map(t => {
        this.colophonText = this.colophonText + t.text + '\n'
      })
    },
    $route(to, from) {
      if (to.name === 'video') {
        this.hideNavigation()
        // Set index of image-TOC to current active video index
        this.imageSlider.index = this.main.works.find(e => e.slugs[0] === to.params.slug).data.order - 1
      } else {
        this.mobileAbout = false
        this.mobileQuotes = false
        this.showNavigation()
        this.scrollUpAllQuarts()
      }
    }
  }
}
</script>

<style lang='scss'>
@import './style/helpers/_mixins.scss';
@import './style/helpers/_responsive.scss';
@import './style/helpers/_reset.css';
@import './style/_variables.scss';
@import './style/perfect-scrollbar.css';
@import './assets/fonts/impact/stylesheet.css';
@import './assets/fonts/Infini/Infini.css';
@import './assets/fonts/Infini/infini-italic.css';
@import './assets/fonts/Courier/Courier.css';

body,
html {
  overflow: hidden;
}

#app {
  font-family: $courier;
  font-size: $fs-m;
  line-height: $lh-m;
  color: $black;
  background: $black;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: fixed;
  height: 100%;
  width: 100vw;
  overflow: hidden;
  @include screen-size('small') {
    font-size: $normal-typesize-mobile;
    line-height: $normal-lineheight-mobile;
  }
}

em {
  font-style: italic !important;
}

h1 {
  font-size: $fs-xl;
  line-height: $lh-xl;
  font-family: $impact;
  @include screen-size('small') {
    font-size: $normal-typesize-mobile;
    line-height: $normal-lineheight-mobile;
  }
}

p {
  font-size: $fs-l;
  line-height: $lh-l;
  @include screen-size('small') {
    font-size: $normal-typesize-mobile;
    line-height: $normal-lineheight-mobile;
  }
}

.colophon {
  position: absolute;
  background: $black;
  width: 100vw;
  height: 100%;
  color: $white !important;
  z-index: 1;
  @include screen-size('small') {
    padding-top: $shemargin-mobile * 2;
  }
}

.toggle-area {
  position: absolute;
  z-index: 1;
  cursor: pointer;
}

.mid {
  margin-left: $shemargin;
  margin-right: auto;
}

.right {
  text-align: right;
}

.quart {
  width: 50vw;
  height: 50%;
  position: absolute;
  padding: 0 $shemargin;
  overflow: hidden;
  z-index: 3;

  .content {
    padding-bottom: $shemargin;
    margin-bottom: $shemargin;

    img {
      width: 100%;
      height: auto;
    }
  }

  .txt {
    height: $shemargin;
    display: flex;
    justify-content: space-between;

    p {
      font-size: $fs-m;
      line-height: $shemargin;
    }
  }

  @include screen-size('small') {
    padding: 0 $shemargin-mobile;

    .content {
      padding-bottom: $shemargin-mobile;
      margin-bottom: $shemargin-mobile;
    }

    p {
      font-size: $normal-typesize-mobile;
      line-height: $normal-lineheight-mobile;
    }

    .txt {
      height: $shemargin-mobile;
      margin-bottom: 10px;

      p {
        font-size: 12px;
        line-height: $shemargin-mobile;
      }
    }
  }

  &.credits {
    right: 0;
    top: 0;
    background: $red;
    color: $red;
    font-family: $infini;
    padding-top: $shemargin;
    line-height: 1em;
    text-shadow: $lila-shade;
    font-size: $fs-l;
    transition: transform $timing $easing;
    will-change: transform;
    overflow: hidden;
    text-transform: uppercase;

    a {
      color: red;
      &:hover {
        text-decoration: none;
      }
    }

    &.collapsed {
      cursor: pointer;
      transform: translateY(calc(-100% + #{$shemargin}));
      transition: transform $timing $easing;

      p {
        display: none !important;
      }
    }

    &.hidden {
      transform: translateY(calc(-100%));
      transition: transform $timing $easing;
    }

    .toggle-area {
      bottom: 0;
      left: 0;
      height: $shemargin;
      width: 100%;
    }

    .colophon-link {
      color: $red;
      text-decoration: none;
      font-size: inherit;
      text-align: right;
      float: right;
      margin-bottom: $lh-l;
      margin-top: -($lh-l/2);
      width: 100%;
    }

    .ps__rail-y {
      background: transparent;
      width: $shemargin;
      padding-top: $shemargin;
      .ps__thumb-y {
        margin-right: 10px;
        background: $blue;
        width: 16px;
        border-radius: 10px;
      }
    }

    pre {
      line-height: 1.3em;
    }

    p {
      padding-bottom: $line-height !important;
    }

    @include screen-size('small') {
      width: 100vw;
      height: 100%;
      z-index: 3;
      padding-top: 4 * $shemargin-mobile;
      padding-bottom: 4 * $shemargin-mobile;
      transform: translateY(calc(-100%));
      overflow-y: auto;
      @include hide-scroll();

      p {
        font-size: 22px;
        line-height: 26px;
      }

      pre {
        font-size: 22px;
        line-height: 26px;
      }

      &.show-mobile {
        transform: translateY(0);
      }

      .toggle-area {
        height: $shemargin-mobile;
      }
    }
  }

  &.about {
    font-family: $impact;
    color: $black;
    bottom: 0;
    left: 0;
    background: $brown;
    transition: transform $timing $easing;
    will-change: transform;

    .content {
      padding: $shemargin;
      background: $skin;
      height: auto;
    }

    &.collapsed {
      overflow: hidden;
      cursor: pointer;
      transform: translateY(calc(100% - #{$shemargin}));
      transition: transform $timing $easing;
    }

    &.hidden {
      transform: translateY(calc(100%));
      transition: transform $timing $easing;
    }

    .toggle-area {
      top: 0;
      left: 0;
      width: 100%;
      height: $shemargin;
    }

    .header {
      height: 40px;
      line-height: 40px;
    }

    pre {
      white-space: pre-wrap;
      word-wrap: break-word;
      font-size: $fs-m;
      line-height: $lh-m;
    }

    .ps__rail-y {
      background: transparent;
      width: $shemargin;
      padding-top: $shemargin;
      .ps__thumb-y {
        margin-right: 10px;
        background: $mint;
        width: 16px;
        border-radius: 10px;
      }
    }

    @include screen-size('small') {
      width: 100vw;
      height: 100%;
      padding-top: 2 * $shemargin-mobile;
      padding-bottom: 4 * $shemargin-mobile;
      top: 0;
      left: 0;
      transform: translateY(calc(-100%));
      overflow-y: auto;
      z-index: 3;
      @include hide-scroll();

      pre {
        font-size: $normal-typesize-mobile;
        line-height: $normal-lineheight-mobile;
      }

      .header {
        visibility: hidden;
      }

      .content {
        padding: $shemargin-mobile;
      }

      &.collapsed {
        transform: translateY(calc(-100%));
      }

      &.show-mobile {
        transform: translateY(0);
      }

      .toggle-area {
        height: $shemargin-mobile;
      }
    }
  }

  &.index {
    font-family: $impact;
    bottom: 0;
    right: 0;
    background: $mint;
    color: $black;
    transition: transform $timing $easing;
    will-change: transform;

    &.collapsed {
      overflow: hidden;
      cursor: pointer;
      transform: translateX(calc(100% - #{$shemargin}));
      transition: transform $timing $easing;
    }

    &.hidden {
      transform: translateX(calc(100%));
      transition: transform $timing $easing;
    }

    .content {
      display: flex;
      justify-content: center;
      align-items: center;
      pointer-events: none;
    }

    a {
      color: $black;
    }

    .nav-arrow {
      cursor: pointer;

      &:hover {
        opacity: 0.6;
      }
    }

    .ps__rail-y {
      background: transparent;
      width: $shemargin;
      padding-top: $shemargin;
      .ps__thumb-y {
        margin-right: 10px;
        background: $brown;
        width: 16px;
        border-radius: 10px;
      }
    }

    .slide-navigation {
      position: absolute;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: calc(100% - 80px);
      z-index: 100;
      left: 40px;
      margin-top: 10px;

      @include screen-size('small') {
        margin-top: 0;
        font-size: 12px;
        left: 40px;
        width: calc(100% - 80px);

        .nav-arrow {
          font-size: 30px;
        }
      }
    }

    .toggle-area {
      z-index: 5;
      top: 0;
      left: 0;
      height: 100%;
      width: $shemargin;
    }

    .vertical-title {
      height: $shemargin;
      line-height: $shemargin;
      position: absolute;
      left: 0;
      transform: rotateZ(90deg) translateX(-$shemargin-mobile);
      transform-origin: bottom left;
    }

    @include screen-size('small') {
      width: 100vw;
      padding-top: 0;
      height: 50%;
      overflow-y: auto;
      @include hide-scroll();

      .toggle-area {
        z-index: 5;
        top: 0;
        left: 0;
        width: 100%;
        height: $shemargin !important;
      }

      .vertical-title {
        margin-left: $shemargin-mobile;
        transform: none;
      }

      &.collapsed {
        transform: translateY(calc(100% - #{$shemargin-mobile * 2}));
        .txt,
        .text-index,
        .image-index {
          display: none;
        }
      }

      &.hidden {
        transform: translateY(calc(100%));
      }

      .toggle-area {
        height: 80%;
      }
    }
  }
}

.title {
  width: 94vh;
  height: 94vh;
  background: $lila;
  position: absolute;
  left: 3vh;
  top: 3vh;
  text-align: center;
  z-index: 4;
  display: inline-block;

  #title {
    width: 100%;
    height: 100%;
  }

  #close {
    position: absolute;
    display: block;
    width: 20px;
    height: 20px;
    right: 3vh;
    top: 3vh;
    z-index: 100;
    cursor: pointer;
  }

  @include screen-size('small') {
    top: $shemargin-mobile * 3;
    width: 90vw;
    left: 5vw;
    height: calc(50% - #{$shemargin-mobile * 4});

    #close {
      width: 14px;
      height: 14px;
    }
  }
}

.vue-typer {
  margin: $shemargin;
  font-family: $courier;
  font-size: 17px;
  display: block;
  white-space: pre-wrap;
  word-wrap: break-word;

  span {
    display: block;
  }

  .custom.char {
    color: $white !important;

    &.selected {
      background: transparent;
    }
  }

  .custom.caret {
    display: none;
  }

  @include screen-size('small') {
    margin: $shemargin-mobile;
    font-size: $colophon-typesize-mobile;
    line-height: $colophon-typesize-mobile;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
  will-change: opacity;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.text-index {
  background: $brown;
  min-height: 100%;
  font-size: $fs-m;
  line-height: 1.4em;

  .text-index-item {
    display: flex;
    .index-number {
      width: 50px;
      @include screen-size('small') {
        width: 35px;
      }
      height: 100%;
    }
    .index-title {
      width: calc(100% - 70px);
      span {
        border-bottom: 3px solid transparent;
      }
    }
  }

  ol {
    padding: $shemargin;
    list-style: none;
  }

  a {
    color: $black;
    text-decoration: none;

    &:hover {
      .index-title {
        span {
          border-bottom: 3px solid $black;
        }
      }
    }
  }

  @include screen-size('small') {
    font-size: $normal-typesize-mobile;

    ol {
      padding: $shemargin-mobile;
    }
  }
}

.index-switch {
  cursor: pointer;

  &.active {
    border-bottom: 3px solid $black;
  }
}

#img-slide-wrapper {
  height: calc(50vh - 80px);
  overflow: hidden;

  div {
    height: 100%;

    img {
      max-height: 100%;
      margin-left: auto;
      margin-right: auto;
      display: block;
    }
  }

  @include screen-size('small') {
    height: calc(40vh - 50px);
    div {
      img {
        max-height: 90%;
      }
    }
  }
}

.mobile-nav {
  display: none;

  @include screen-size('small') {
    cursor: pointer;
    display: block;
    position: fixed;
    z-index: 100;
    top: 0;
    width: 50vw;
    height: $shemargin-mobile * 2;
    line-height: $shemargin-mobile * 2;
    font-size: 12px;
    padding: 0 $shemargin-mobile;
    font-family: $impact;
    transition: transform $timing $easing;
    will-change: transform;
  }

  &.about {
    left: 0;
    background: $brown;
    text-align: left;
  }

  &.quotes {
    right: 0;
    background: $red;
    color: $black;
    text-align: right;
  }

  &:active {
    background: $white;
  }

  &.hidden {
    transform: translateY(-100%);
    transition: transform $timing $easing;
  }
}

#close-video {
  height: 44px;
  width: 44px;
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 3;
  opacity: 1;
  transition: opacity 0.5s $easing;
  will-change: opacity;

  svg {
    polygon {
      fill: $white;
    }
  }

  &:hover,
  &:active {
    svg {
      polygon {
        fill: $mint;
      }
    }
  }

  &.hidden {
    opacity: 0;
  }

  @include screen-size('small') {
    top: auto;
    bottom: 20px;
  }
}

.preloader {
  display: none;
}

pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// App.vue?1c5f44aa